import angular from 'angular';
import showBudgetTemplate from './showBudget.template.html';
import './budgets.css';
import booksMenu from '../../menu/Menu';
/** Services */
import { BudgetServices } from './services/Budgets';
/** Dialogs */
import { addEditBudgetItemDialog } from './dialogs/addEditBudgetItemDialog';
import { createNewBudgetDialog } from './dialogs/createNewBudgetDialog';

// TODO: GR-329, Once ASBWorks is updated we can remove the dependency on here. It was just throwing console
// errors because ASBWorks is the one with the dependency on this file.
export default angular
  .module('budgets', [booksMenu, 'ui.grid', 'ui.grid.resizeColumns'])
  .service('BudgetSvc', BudgetSvc)
  /*****************************************************************************
   * showBudget */
  /**
   * @ngdoc   component
   * @module  books.client.apps.budgets
   * @name    books.client.apps.budgets.component:showBudget
   *
   * @description Component that displays budgets allowing the user to create,
   * delete and edit budgets and budget items for the organization.
   *****************************************************************************/
  .component('showBudget', {
    template: showBudgetTemplate,
    controller: showBudgetController
  })
  .service('Budgets', BudgetServices)
  .service('addEditBudgetItemDialog', addEditBudgetItemDialog)
  .service('createNewBudgetDialog', createNewBudgetDialog).name;

BudgetSvc.$inject = [];

/*******************************************************************************
 * BudgetSvc */
/**
 * Service used to pass objects and properties from the controller to the
 * component. This is called during the initialization of the component.
 *******************************************************************************/
/* @ngInject */ function BudgetSvc() {
  return { init: angular.noop };
}

/*******************************************************************************
 * showBudgetController */
/**
 * Main controller for the budgets app.
 *******************************************************************************/
/* @ngInject */ function showBudgetController($injector, $scope) {
  var $ctrl = this;

  var $utils = {};
  $utils.buildDG = $injector.invoke(buildDG, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $utils.buildDGAccountClassItems = $injector.invoke(
    buildDGAccountClassItems,
    null,
    { $ctrl: $ctrl, $utils: $utils }
  );
  $utils.buildDGAccountItems = $injector.invoke(buildDGAccountItems, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $utils.buildDGItem = $injector.invoke(buildDGItem, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $utils.createNewBudgetList = $injector.invoke(createNewBudgetList, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $utils.updateBudgetTotals = $injector.invoke(updateBudgetTotals, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $utils.yearRange = $injector.invoke(yearRange, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });

  $ctrl.incomeGrid = $injector.invoke(buildGrid, null, { $ctrl: $ctrl });
  $ctrl.expensesGrid = $injector.invoke(buildGrid, null, { $ctrl: $ctrl });

  $ctrl.createNewBudget = $injector.invoke(createNewBudget, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $ctrl.deleteBudget = $injector.invoke(deleteBudget, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $ctrl.editItem = $injector.invoke(editItem, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $ctrl.loadBudget = $injector.invoke(loadBudget, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $ctrl.printBudget = $injector.invoke(printBudget, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });
  $ctrl.saveCurrentBudget = $injector.invoke(saveCurrentBudget, null, {
    $ctrl: $ctrl,
    $utils: $utils
  });

  $injector.invoke(init, null, { $ctrl: $ctrl, $utils: $utils });
}

/*******************************************************************************
 * buildGrid */
/**
 * Builds the grid options to be displayed in each of the grids. The first two
 * columns will always be the same, so they are the only ones created here. The
 * rest of the columns will be created using the columns array.
 *******************************************************************************/
/* @ngInject */ function buildGrid(uiGridConstants) {
  /*--------------------------------------------------*/
  /* Template utilized when user double clicks a row. */
  /*--------------------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.$ctrl.editItem(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  var gridOptions = {
    enableColumnMenus: false,
    enableColumnResizing: true,
    enableRowSelection: true,
    enableSorting: false,
    enableFiltering: false,
    enableFullRowSelection: true,
    enableRowHeaderSelection: false,
    multiSelect: false,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    rowTemplate: dblClickTemplate,
    data: [],
    columnDefs: [
      {
        field: 'Name',
        displayName: 'Name',
        cellTooltip: true,
        width: 250,
        pinnedLeft: true,
        type: 'string',
        cellClass: function (grid, row) {
          if (row.entity.headerRow) return 'headerRow';
          if (row.entity.indent) return 'textIndent';
          if (row.entity.accountID == 0) return 'boldText';
        }
      },
      {
        field: 'TotalAmt',
        displayName: 'Annual Total',
        width: 150,
        pinnedLeft: true,
        cellFilter: 'currency',
        cellClass: 'annualAmt'
      }
    ]
  };

  return gridOptions;
}

/*****************************************************************************
 * buildDG
 *
 * Builds the data objects info to be displayed in the income and expenses grids
 *****************************************************************************/
/* @ngInject */ function buildDG($utils, $ctrl, SERVER) {
  return function () {
    $ctrl.incomeGrid.data = $utils.buildDGAccountClassItems(
      'Income',
      SERVER.BooksDBConstants.AC_REVENUE,
      SERVER.BooksDBConstants.ASC_REVENUE_NON_UNIT
    );
    $ctrl.expensesGrid.data = $utils.buildDGAccountClassItems(
      'Expenses',
      SERVER.BooksDBConstants.AC_EXPENSE,
      SERVER.BooksDBConstants.ASC_EXPENSE_NON_UNIT
    );

    /*--------------------------------------------------*/
    /* Update the budget totals if the totals are shown */
    /*--------------------------------------------------*/
    if ($ctrl.showTotals) $utils.updateBudgetTotals();
  };
}

/*****************************************************************************
 * buildDGAccountClassItems */
/**
 * Builds the Income/Expense account class section of the budget datagrid. For
 * categories and passthru categories we simply build the items from the chart
 * of accounts by calling the buildDGAccountItems function.
 *
 * Fundraisers and programs are handled differently. We have to look at the
 * classList of fundraisers and programs and group any income and/or expense
 * categories to the fundraiser/program and display them together in the
 * respective grid. The buildDGClassItems function looks at the classList and
 * calls the buildDGAccountItems function to build the grid objects.
 *
 * @param  header        "Income" or "Expenses"
 * @param  acctClass     Account Class to Include
 * @param  acctSubClass  Sub-Class of Non-Association Accounts
 * @returns              Account Class Section
 *****************************************************************************/
/* @ngInject */ function buildDGAccountClassItems($utils, SERVER, BudgetSvc) {
  return function (header, acctClass, acctSubClass) {
    var items = $utils.revenueExpenseOnly ? [] : [{ headerRow: true }];

    var fundraisers = [];
    var programs = [];
    var nonUnitAccts = [];
    /*-------------------------------------*/
    /* Build the Administration categories */
    /*-------------------------------------*/
    var accts = $utils.buildDGAccountItems(acctClass, 0);

    /*------------------------------------*/
    /* Build the fundraisers and programs */
    /*------------------------------------*/
    if (!$utils.revenueExpenseOnly) {
      fundraisers = BudgetSvc.buildDGClassItems(
        SERVER.BooksDBConstants.CT_FUNDRAISER,
        acctClass,
        $utils.buildDGAccountItems,
        $utils.buildDGItem
      );
      programs = BudgetSvc.buildDGClassItems(
        SERVER.BooksDBConstants.CT_PROGRAM,
        acctClass,
        $utils.buildDGAccountItems,
        $utils.buildDGItem
      );

      /*------------------------------*/
      /* Load the Non-Unit categories */
      /*------------------------------*/
      nonUnitAccts = $utils.buildDGAccountItems(acctClass, acctSubClass);
    }

    /*----------------------------------------*/
    /* Build the items for the account class. */
    /*----------------------------------------*/
    if (accts.length > 0)
      items = items.concat({ Name: 'Administration', headerRow: true }, accts);

    if (fundraisers.length > 0)
      items = items.concat(
        { acctClass: acctClass },
        { Name: 'Fundraisers', headerRow: true },
        fundraisers
      );

    if (programs.length > 0)
      items = items.concat(
        { acctClass: acctClass },
        { Name: 'Programs', headerRow: true },
        programs
      );

    if (nonUnitAccts.length > 0)
      items = items.concat(
        { acctClass: acctClass },
        { Name: 'Non-Unit ' + header, headerRow: true },
        nonUnitAccts
      );

    items.shift();
    return items;
  };
}

/*****************************************************************************
 * buildDGAccountItems */
/**
 * Builds datagrid items for accounts matching account class and subclass.
 * acctSubClass is ignored if NaN.
 *
 * @param  acctClass     Account Class to Include
 * @param  acctSubClass  Account Sub-Class to Include, NaN=Ignore
 * @param  classID       Class ID associated to Account.
 * @returns              Account Section
 *****************************************************************************/
/* @ngInject */ function buildDGAccountItems($utils) {
  return function (acctClass, acctSubClass, classID) {
    var allAccounts = $utils.accounts.revenueActs.concat(
      $utils.accounts.expenseActs
    );
    return allAccounts
      .map(function (a) {
        if (
          a.accountClass == acctClass &&
          (isNaN(acctSubClass) || a.subClass == acctSubClass) &&
          (a.classID || null) == (classID || null)
        )
          return $utils.buildDGItem(
            acctClass,
            a.accountID,
            0,
            a.accountName,
            !a.active
          );
        return null;
      })
      .filter(function (e) {
        return e != null;
      });
  };
}

/*****************************************************************************
 * buildDGItem */
/**
 * Returns the budget datagrid item for the account or class built from the
 * current budget items. If requireMatch is true, an existing budget item
 * needs to exist, otherwise null will be returned and the account will not be
 * displayed.
 *
 * @param  acctClass      Account Class
 * @param  acctID         Account ID, 0=Class
 * @param  classID        Class ID,   0=Account
 * @param  name           Account/Class Name
 * @param  requireMatch   Requires an existing BudgetItem is available
 * @return                Budget Datagrid Item
 *****************************************************************************/
/* @ngInject */ function buildDGItem($utils, SERVER, Tools) {
  return function (acctClass, acctID, classID, name, reqiureMatch) {
    /*---------------------------------------*/
    /* Get any items for this Account/Class. */
    /*---------------------------------------*/
    var items = $utils.currentItems.filter(function (i) {
      return (
        (acctID != 0 && i.AccountID == acctID) ||
        (classID != 0 && i.ClassID == classID)
      );
    });

    /*-------------------------------------------------*/
    /* Return null for an existing budget with no      */
    /* matching items and a matching item is required. */
    /*-------------------------------------------------*/
    if (items.length == 0 && reqiureMatch) return null;

    /*--------------------------------*/
    /* Create a new datagrid item and */
    /* load with line item amounts.   */
    /*--------------------------------*/
    var item = new BudgetDGItem(name, acctID, classID, acctClass);

    items.forEach(function (i) {
      var month = 'month' + i.Month;
      var amt =
        acctClass == SERVER.BooksDBConstants.AC_REVENUE ? i.Revenue : i.Expense;
      item[month] = amt;
      item.TotalAmt += amt;
    });

    item.TotalAmt = item.TotalAmt > 0 ? Tools.roundMoney(item.TotalAmt) : null;
    return item;
  };
}

/*****************************************************************************
 * BudgetDGItem
 *
 * Used to create the item object in the buildDGItem function
 *****************************************************************************/
function BudgetDGItem(name, accountID, classID, acctClass) {
  this.Name = name;
  this.accountID = accountID;
  this.classID = classID;
  this.acctClass = acctClass;
  this.TotalAmt = 0;
}

/*****************************************************************************
 * BudgetItem
 *
 * Used when saving a budget. Creates the object to be saved.
 *****************************************************************************/
function BudgetItem(name, month, acctID, classID, revenue, expense) {
  this.Name = name;
  this.Month = month;
  this.AccountID = acctID;
  this.ClassID = classID;
  this.Revenue = revenue;
  this.Expense = expense;
}

/*****************************************************************************
 * init
 *
 * Initialize the app
 *****************************************************************************/
/* @ngInject */ function init(
  BusyScreen,
  Budgets,
  $ctrl,
  $utils,
  $q,
  BudgetSvc
) {
  BusyScreen.promise(
    $q
      .all([
        BudgetSvc.init(),
        Budgets.getFYMonth().then(function (fyMonth) {
          $utils.fyMonth = fyMonth;
          $utils.newBudget = false;
          $utils.unsavedChanges = false;
          $ctrl.req = { reportFormat: 'PDF' };

          /*-------------------------------------------------------*/
          /* Template for the actions options added to each grid   */
          /* row for each row that has an accountID or classID.    */
          /* Rows without these ID's are not allowed to be edited. */
          /*-------------------------------------------------------*/
          var actionsCellTemplate =
            '<div ng-if="row.entity.accountID || row.entity.classID" class="ui-grid-cell-contents" style="margin-left:13px">' +
            '<span class="pointer glyphicon glyphicon-edit csm-grid-space-target" title="Edit Budget" ng-click="grid.appScope.$ctrl.editItem(row)"></span> &nbsp;' +
            '</div>';

          /*---------------------------------------------------------------*/
          /* Array of columns to display in the UI-Grid. This gets spliced */
          /* at the fiscal year month so that the first month displayed is */
          /* the first month in the fiscal year for the orgainzation.      */
          /*---------------------------------------------------------------*/
          var columns = [
            {
              value: 1,
              field: 'month1',
              displayName: 'Jan',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 2,
              field: 'month2',
              displayName: 'Feb',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 3,
              field: 'month3',
              displayName: 'Mar',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 4,
              field: 'month4',
              displayName: 'Apr',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 5,
              field: 'month5',
              displayName: 'May',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 6,
              field: 'month6',
              displayName: 'Jun',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 7,
              field: 'month7',
              displayName: 'Jul',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 8,
              field: 'month8',
              displayName: 'Aug',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 9,
              field: 'month9',
              displayName: 'Sep',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 10,
              field: 'month10',
              displayName: 'Oct',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 11,
              field: 'month11',
              displayName: 'Nov',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            },
            {
              value: 12,
              field: 'month12',
              displayName: 'Dec',
              width: 105,
              cellFilter: 'currency',
              enableColumnResizing: true
            }
          ];

          /*------------------------------------------------------------*/
          /* Splice the columns array based on the fyMonth, then concat */
          /* what was not included in the splice and add the last two   */
          /* columns to the end to create the columns in the grid.      */
          /*------------------------------------------------------------*/
          var cols = columns
            .splice(fyMonth - 1, columns.length - (fyMonth - 1))
            .concat(columns, [
              {
                value: 13,
                field: 'actions',
                displayName: 'Action',
                width: 80,
                cellTemplate: actionsCellTemplate,
                pinnedRight: true,
                enableColumnResizing: false
              }
            ]);

          [].splice.apply(
            $ctrl.incomeGrid.columnDefs,
            [$ctrl.incomeGrid.columnDefs.length, 0].concat(cols)
          );
          [].splice.apply(
            $ctrl.expensesGrid.columnDefs,
            [$ctrl.expensesGrid.columnDefs.length, 0].concat(cols)
          );
        }),

        /*----------------------------------*/
        /* Get the organization information */
        /*----------------------------------*/
        Budgets.getOrganization().then(function (org) {
          $ctrl.org = org;
          $utils.openingDate = org.openDate;
        }),

        /*----------------------------------------------------------*/
        /* Get the list of budgets for the orgainzation and create  */
        /* a yearRange to be displayed in the budget year selection */
        /*----------------------------------------------------------*/
        Budgets.viewBudgets().then(function (list) {
          $ctrl.budgets = list.map(function (b) {
            return (
              (b.yearRange = b.FiscalYear + ' - ' + (b.FiscalYear + 1)),
              b
            );
          });
        }),

        /*-----------------------------------*/
        /* Get the list of accounts (Chart   */
        /* of accounts) for the organization */
        /*-----------------------------------*/
        Budgets.getAccounts().then(function (accounts) {
          $utils.accounts = accounts;
        })
      ])
      .then(function () {
        /*-------------------------------------------*/
        /* Check for a budget for the current fiscal */
        /* year. If found, load it as a default      */
        /*-------------------------------------------*/
        var thisYear = new Date().getFullYear();
        var thisMonth = new Date().getMonth();
        $utils.thisFiscalYear =
          thisMonth + 1 >= $utils.fyMonth ? thisYear : thisYear + 1;
        $ctrl.selectedBudget = $ctrl.budgets.find(function (b) {
          return b.FiscalYear == $utils.thisFiscalYear;
        });
        /*----------------------------------------------------------------------*/
        /* Get the data from the BudgetSvc service and set it on the component. */
        /* The classList is the list of fundraisers and programs, showTotals    */
        /* will display/hide the budget totals and revenueExpenseOnly will      */
        /* exclude fundraiser, programs and non unit amounts.                   */
        /*----------------------------------------------------------------------*/
        $ctrl.showTotals = BudgetSvc.showTotals;
        $utils.revenueExpenseOnly = BudgetSvc.revenueExpenseOnly;
        $utils.createNewBudgetList();

        if (!$ctrl.selectedBudget) return;

        $ctrl.loadBudget();
      })
  );
}

/*****************************************************************************
 * createNewBudget
 *
 * Opens the new budget dialog allowing the user to create a new budget and
 * copy it from an existing budget. The new budget will automatically be saved
 * when the dialog closes.
 *****************************************************************************/
/* @ngInject */ function createNewBudget(createNewBudgetDialog, $ctrl, $utils) {
  return function () {
    if (!$ctrl.allowCreate) return;

    createNewBudgetDialog
      .show($ctrl.budgets, $ctrl.newBudgetList)
      .then(function (budget) {
        $utils.newBudget = true;
        $utils.budgetCopyID = budget.budgetCopyID;
        $utils.newFY = budget.newBudgetFY;
        $ctrl.saveCurrentBudget();
      });
  };
}

/*****************************************************************************
 * createNewBudgetList
 *
 * Creates the array of budgets that can be added.
 *****************************************************************************/
/* @ngInject */ function createNewBudgetList($utils, $ctrl) {
  return function () {
    var openingYear = $utils.openingDate.getFullYear();
    var numberYears = $utils.thisFiscalYear - openingYear + 3;
    var list = [];

    /*-----------------------------------------------------------*/
    /* Create the list of years that budgets can be created      */
    /* for. The first year will be the opening year and the      */
    /* last year will be 2 years beyond the current fiscal year. */
    /*-----------------------------------------------------------*/
    for (var i = 0; i < numberYears; i++) {
      var budgetYears = {
        ID: 0,
        FiscalYear: openingYear + i,
        yearRange: $utils.yearRange(openingYear + i)
      };
      list.push(budgetYears);
    }

    /*---------------------------------------------------------------------*/
    /* If there is already a budget for any of the years created in the    */
    /* list, remove it from the list of years a budget can be created for. */
    /*---------------------------------------------------------------------*/
    for (var k = 0; k < $ctrl.budgets.length; k++) {
      var budgetFound = list.find(function (l) {
        return l.FiscalYear == $ctrl.budgets[k].FiscalYear;
      });
      if (budgetFound) list.removeItem(budgetFound);
    }

    /*-----------------------------------------*/
    /* Enables the create new budget button if */
    /* there are budgets that can be created.  */
    /*-----------------------------------------*/
    $ctrl.allowCreate = list.length > 0;
    return ($ctrl.newBudgetList = list);
  };
}

/*****************************************************************************
 * deleteBudget
 *
 * Deletes the selected budget
 *****************************************************************************/
/* @ngInject */ function deleteBudget(
  $utils,
  $ctrl,
  Budgets,
  Alert,
  BusyScreen
) {
  return function () {
    if (!$ctrl.selectedBudget) return;

    /*------------------------------------------------*/
    /* Make sure the user wants to remove the budget. */
    /*------------------------------------------------*/
    Alert.confirm(
      'Are you sure you want to delete this entire budget? This will delete the ' +
        $ctrl.selectedBudget.yearRange +
        ' budget, not a budget item.',
      'Deleting Entire ' + $ctrl.selectedBudget.FiscalYear + ' Budget!'
    ).then(function (result) {
      if (result.type == Alert.OK)
        BusyScreen.promise(
          Budgets.deleteBudget($ctrl.selectedBudget.ID).then(
            function () {
              /*--------------------------------------------------------*/
              /* Once the budget has been deleted, clear the grids,     */
              /* remove the budget from the budgets object, clear the   */
              /* selectedBudget, create a new budgetList and loadBudget */
              /*--------------------------------------------------------*/
              Alert.success(
                'Budget has been deleted',
                $ctrl.selectedBudget.FiscalYear
              );
              $ctrl.incomeGrid.data = [];
              $ctrl.expensesGrid.data = [];
              $ctrl.budgets.removeItem($ctrl.selectedBudget);
              $ctrl.selectedBudget = null;
              $utils.createNewBudgetList();
              $ctrl.loadBudget();
            },
            function (resp) {
              Alert.error(resp.parsedResponse.message());
            }
          )
        );
    });
  };
}

/*****************************************************************************
 * editItem
 *
 * Opens the addEditBudgetItemDialog to edit a budget item.
 *
 * @param   dgi  Data grid item to be edited.
 *****************************************************************************/
/* @ngInject */ function editItem(addEditBudgetItemDialog, $utils, $ctrl) {
  /*-----------------------------------------------*/
  /* The entire row object is passed in so the     */
  /* row.entity can be set when the promise is     */
  /* resolved and the updated item is passed back. */
  /*-----------------------------------------------*/
  return function (dgi) {
    if (dgi.entity.headerRow || !dgi.entity.Name) return;

    /*-----------------------------------------------------*/
    /* Create a copy of the dgi.entity object in case the  */
    /* user closes the modal by hitting the escape button. */
    /*-----------------------------------------------------*/
    var dgiEntity = angular.extend({}, dgi.entity);

    addEditBudgetItemDialog.show(dgi.entity, $utils.fyMonth).then(
      function (item) {
        /*------------------------------------------*/
        /* If the amounts were changed, update the  */
        /* totals and set the unsavedChages to true */
        /*------------------------------------------*/
        if (item.updated) {
          dgi.entity = item;
          $utils.unsavedChanges = true;

          if ($ctrl.showTotals) $utils.updateBudgetTotals();
        }
      },
      function (cancel) {
        /*------------------------------------------------------*/
        /* If the promise is rejected (user hits the escape     */
        /* key) reset the grid row to what was originally there */
        /*------------------------------------------------------*/
        dgi.entity = dgiEntity;
      }
    );
  };
}

/*****************************************************************************
 * loadBudget
 *
 * Loads the budget items for the year selected
 *****************************************************************************/
/* @ngInject */ function loadBudget(
  $ctrl,
  $utils,
  $q,
  BusyScreen,
  Budgets,
  Tools,
  Alert
) {
  return function () {
    if (!$ctrl.selectedBudget) return;

    if ($ctrl.showTotals) {
      Budgets.getCashBalanceForward($ctrl.selectedBudget.FiscalYear).then(
        function (balance) {
          $ctrl.balanceForward = Tools.roundMoney(balance);
        }
      );
    }

    /*--------------------------------------*/
    /* Load the selected budget and get the */
    /* cash balance forward to be displayed */
    /*--------------------------------------*/
    function load() {
      BusyScreen.promise(
        $q
          .all([
            /*-----------------------------------------------*/
            /* Get the budget items for the selected budget. */
            /*-----------------------------------------------*/
            $q
              .when(
                $ctrl.selectedBudget.ID
                  ? Budgets.viewBudgetItems($ctrl.selectedBudget.ID)
                  : []
              )
              .then(function (items) {
                $utils.unsavedChanges = false;
                $utils.currentItems = items;
                $utils.previousBudget = $ctrl.selectedBudget;
              })
          ])
          .then($utils.buildDG)
      );
    }

    /*-------------------------------------------------*/
    /* If the Alert is confirmed, load the new budget. */
    /*-------------------------------------------------*/
    function confirmed() {
      load();
    }

    /*-------------------------------------------------------*/
    /* If the Alert is not confirmed, set the                */
    /* selectedBudget back to what it was before the change. */
    /*-------------------------------------------------------*/
    function unconfirmed() {
      $ctrl.selectedBudget = $utils.previousBudget;
    }

    /*--------------------------------------------------------*/
    /* Check for unsaved changes. Notify the user if there    */
    /* are unsaved changes and confirm they want to continue. */
    /*--------------------------------------------------------*/
    if (!$utils.unsavedChanges) load();
    else {
      Alert.confirm(
        'You have unsaved changes to the current budget. Would you like to continue?',
        'Unsaved changes'
      ).then(confirmed, unconfirmed);
    }
  };
}

/*****************************************************************************
 * printBudget */
/**
 * Print button handler. Prints the selected budget in the selected format.
 *****************************************************************************/
/** @ngIngject */ function printBudget($ctrl) {
  return function () {
    var pageURL =
      'BudgetReport.aspx?bid=' +
      $ctrl.selectedBudget.ID +
      '&rt=' +
      $ctrl.req.reportFormat;

    window.open(pageURL);
  };
}

/*****************************************************************************
 * saveCurrentBudget */
/**
 * Save button handler.  Saves the current budget. Called on the save budget
 * button and when creating a new budget.
 *****************************************************************************/
/* @ngInject */ function saveCurrentBudget(
  $ctrl,
  $utils,
  SERVER,
  Budgets,
  BusyScreen,
  Alert
) {
  return function () {
    /*----------------------------------------------------*/
    /* Create the list of items to be saved from the data */
    /* grids. Only look at items that have an acctClass   */
    /* so we don't try to save header or blank rows       */
    /*----------------------------------------------------*/
    var dgItems = $ctrl.incomeGrid.data
      .concat($ctrl.expensesGrid.data)
      .filter(function (e) {
        return e.acctClass;
      });
    var items = [];

    /*----------------------------------------------------------------*/
    /* Loop through the list of dgItems and break out the amount for  */
    /* each month in to an array of items for saving to the database. */
    /*----------------------------------------------------------------*/
    dgItems.forEach(function (dgi) {
      for (var m = 1; m < 13; m++) {
        /*--------------------------------------------------*/
        /* Find the item for the month or create a new one. */
        /*--------------------------------------------------*/
        var item = items
          .filter(function (i) {
            return (
              i.AccountID == dgi.accountID &&
              i.ClassID == dgi.classID &&
              i.Month == m
            );
          })
          .shift();

        if (!item) {
          item = new BudgetItem(null, m, dgi.accountID, dgi.classID);

          /*----------------------------------------------------*/
          /* To prevent the addition of a new budget item from  */
          /* being created for a new account or class when the  */
          /* budget amounts are untouched, we ignore this item. */
          /*----------------------------------------------------*/
          if (dgi.TotalAmt > 0) items.push(item);
        }

        /*---------------------------------------------*/
        /* Get the amount for the calendar month from  */
        /* the fiscal month amount and set in the      */
        /* budget item according to the account class. */
        /*---------------------------------------------*/
        var amtMonth = 'month' + m;
        var amt = dgi[amtMonth];

        if (dgi.acctClass == SERVER.BooksDBConstants.AC_REVENUE) {
          item.Revenue = amt;
        } else item.Expense = amt;
      }
    });

    /*---------------------------------------------------------*/
    /* Set the budgetID and fiscalYear based on if it is a new */
    /* budget. A budgetID of zero will create a new budget.    */
    /*---------------------------------------------------------*/
    var budgetID = $utils.newBudget ? 0 : $ctrl.selectedBudget.ID;
    var FY = $utils.newBudget ? $utils.newFY : $ctrl.selectedBudget.FiscalYear;

    /*--------------------------------------------------------*/
    /* Save the budget to the database. If it is a new budget */
    /* and we are copying the items from an exitsting budget, */
    /* get the items from the database using the budgetCopyID */
    /* and save the new budget again with these items.        */
    /*--------------------------------------------------------*/
    function commit(budgetID, FY, items, addBudget) {
      BusyScreen.promise(
        Budgets.saveBudget(budgetID, FY, items).then(
          function (savedBudgetID) {
            $utils.unsavedChanges = false;

            /*-----------------------------------------------*/
            /* If this is not a new budget, load the budget. */
            /*-----------------------------------------------*/
            if (!addBudget) {
              Alert.success('Budget saved');
              $ctrl.loadBudget();
            } else {
              /*----------------------------------------------------*/
              /* Create a new budget object, set the selectedBudget */
              /* to it and push it on to the budgets array and call */
              /* createNewBudgetList to account for the new budget. */
              /*----------------------------------------------------*/
              $utils.newBudget = false;
              var newBudgetsItem = {
                ID: savedBudgetID,
                FiscalYear: $utils.newFY,
                yearRange: $utils.yearRange($utils.newFY)
              };
              $ctrl.selectedBudget = newBudgetsItem;
              $ctrl.budgets.push(newBudgetsItem);
              $ctrl.budgets.sort(function (a, b) {
                return a.FiscalYear - b.FiscalYear;
              });
              $utils.createNewBudgetList();

              /*---------------------------------------*/
              /* If we are not copying from an         */
              /* existing budget, load the new budget. */
              /*---------------------------------------*/
              if (!$utils.budgetCopyID) {
                $ctrl.loadBudget();
                Alert.success('Budget saved', $utils.newFY);
              } else {
                /*------------------------------------------------------------*/
                /* Otherwise get the list of budgetItems for the budgetCopyID */
                /* and then save the new budget with those items.             */
                /*------------------------------------------------------------*/
                Budgets.viewBudgetItems($utils.budgetCopyID).then(
                  function (items) {
                    $utils.budgetCopyID = null;
                    commit(
                      $ctrl.selectedBudget.ID,
                      $ctrl.selectedBudget.FiscalYear,
                      items,
                      false
                    );
                  }
                );
              }
            }
          },
          function (resp) {
            Alert.error(resp.parsedResponse.message());
          }
        )
      );
    }

    /*-------------------------------------------------------------------*/
    /* If this is a new budget, save the budget with and empty array of  */
    /* items and a budgetID of zero to create a new budet on the server, */
    /* otherwise save the selectedBudget and the items from the grids    */
    /*-------------------------------------------------------------------*/
    if ($utils.newBudget) {
      var newBudgetItems = [];
      commit(0, $utils.newFY, [], true);
    } else {
      commit(
        $ctrl.selectedBudget.ID,
        $ctrl.selectedBudget.FiscalYear,
        items,
        false
      );
    }
  };
}

/*****************************************************************************
 * updateBudgetTotals
 *
 * Update the incomeTotal, expenseTotal and budgetTotal amounts.
 *****************************************************************************/
/* @ngInject */ function updateBudgetTotals(Tools, $ctrl) {
  return function () {
    function getTotal(budgetList) {
      var total = 0;
      var classMap = {};
      budgetList.forEach(function (bi) {
        if (bi.headerRow) return;

        var amt = Number(bi.TotalAmt) || 0;
        var classID = Tools.coalesce(bi.accountClassID, bi.classID);

        /*--------------------------------------------------*/
        /* For admin and non-unit, add the amt to the total */
        /*--------------------------------------------------*/
        if (Tools.isNaNZero(classID)) {
          total += amt;
        } else {
          /*--------------------------------------------------------------------*/
          /* Add the fundraisers and programs to the classMap object. We want   */
          /* to increase the total by either the total of the fundraiser or     */
          /* program, or the total of the items for that fundraiser or program. */
          /* We break out the difference by the presence of the accountClassID. */
          /*--------------------------------------------------------------------*/
          var ci =
            classMap[classID] ||
            (classMap[classID] = {
              classID: classID,
              classTotal: 0,
              accountTotal: 0
            });

          if (Tools.isNaNZero(bi.accountClassID)) ci.classTotal += amt;
          else ci.accountTotal += amt;
        }
      });

      /*-----------------------------------------------------------*/
      /* Increase the total by the higher of the classTotal amount */
      /* or the accountTotal amount for each item in the classMap  */
      /*-----------------------------------------------------------*/
      for (var p in classMap)
        total += Math.max(classMap[p].classTotal, classMap[p].accountTotal);

      return total;
    }

    /*------------------------------------*/
    /* Get the income and expense totals. */
    /*------------------------------------*/
    $ctrl.incomeTotal = getTotal($ctrl.incomeGrid.data);
    $ctrl.expenseTotal = getTotal($ctrl.expensesGrid.data);

    /*--------------------------*/
    /* Calculate the budetTotal */
    /*--------------------------*/
    $ctrl.budgetTotal = function () {
      return $ctrl.balanceForward + $ctrl.incomeTotal - $ctrl.expenseTotal;
    };
  };
}

/*****************************************************************************
 * yearRange
 *
 * Creates a string for the year range display
 *
 * @param year  Year to format
 *****************************************************************************/
/* @ngInject */
var yearRange = function () {
  return function (year) {
    return '{0} - {1}'.format(year, year + 1);
  };
};
